import { styled } from '@mui/material/styles';
import { useDrawingArea } from '@mui/x-charts';

interface CustomPieChartCenterLabelProps {
  outOfRange?: boolean;
  label: {
    text: string;
    fontSize?: number;
    fontWeight?: number;
  };
  secondaryLabel?: string;
}
interface StyledTextProps {
  textType: 'primary' | 'secondary';
  outOfRange?: boolean;
}

const StyledText = styled('text')<StyledTextProps>(
  ({ theme, textType, outOfRange, fontSize, fontWeight }) => ({
    textAnchor: 'middle',
    dominantBaseline: 'middle',
    fontSize: fontSize ?? (textType === 'primary' ? 26 : 14),
    fontWeight,
    fill: outOfRange ? theme.palette.error.main : 'text',
  }),
);

export default function PieChartCenterLabel({
  label: { text, fontSize, fontWeight },
  outOfRange = false,
  secondaryLabel = '',
}: Readonly<CustomPieChartCenterLabelProps>) {
  const { width, height, left, top } = useDrawingArea();
  const centerXAxis = left + width / 2;
  const centerYAxis = top + height / 2;
  return (
    <>
      <StyledText
        x={centerXAxis}
        y={centerYAxis}
        textType="primary"
        outOfRange={outOfRange}
        fontSize={fontSize}
        fontWeight={fontWeight}
      >
        {text}
      </StyledText>
      {secondaryLabel && (
        <StyledText
          x={centerXAxis}
          y={centerYAxis + 30}
          textType="secondary"
          outOfRange={outOfRange}
        >
          {secondaryLabel}
        </StyledText>
      )}
    </>
  );
}
